






























































































import HourSelector from '../../core/components/HourSelector.vue';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import SimpleMap from '../../core/components/SimpleMap.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getDateFormattedAsMoment,
    getMinDateFromList,
    getMaxDateFromList
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment from 'moment';
import { dateTypes } from '../../core/models';

@Component({
    components: {
        Loading,
        SimpleMap,
        Combobox,
        Button,
        DatePickerSingle,
        HourSelector
    }
})
export default class ModalResowing extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() vehicleID: number;
    @Prop({ default(){return []} }) selectedWorkSegments: Array<object>;
    @Prop({ default: null }) patchData: object | null;
    @Prop({ default: -1 }) ranchId: number;
    modalTitle: string = 'Agregar Período de resiembra';
    dateRangeSelected: any = [];
    discardSegment: boolean = false;
    calculateWithoutPerformance: boolean = false;
    ignoreAllFromTelemetry: boolean = false;
    discardPerformance: boolean = false;
    discardHumidity: boolean = false;
    ignoreAllFromCSV: boolean = false;
    discardPerformanceCSV: boolean = false;
    discardHumidityCSV: boolean = false;
    vehicleSelectedRV: boolean = false;
    errorMsg: string = '';
    startDate: any = null;
    vehicleSelected: any = null;
    startHour: string = '';
    endDate: any = null;
    endHour: string = '';
    preselectedMessage: string = 'Se pre-seleccionó la fecha mínima y máxima de la lista de segmentos seleccionados';
    showPreselectedMessage: boolean = false;

    get disableAllButtons() {
        return this.discardSegment;
    }

    get isPatch() {
        if (this.patchData !== null) {
            return true;
        } else {
            return false;
        }
    }

    updateStartDate(value) {
        this.startDate = value;
    }
    updateStartHour(value) {
        this.startHour = value;
    }
    updateEndDate(value) {
        this.endDate = value;
    }
    updateEndHour(value) {
        this.endHour = value;
    }
    updateVehicleSelected(value) {
        this.vehicleSelected = value;
    }
    updateVehicleSelectedRV(value) {
        this.vehicleSelectedRV = value;
    }

    ignorePerformanceFromTelemetry(value) {
        this.uncheckIgnoreAllFromTelemetry();
        this.calculateWithoutPerformance = value;
    }

    clickDiscardSegment(value) {
        this.ignoreAllFromTelemetry = this.discardSegment;
        this.ignoreAllFromCSV = this.discardSegment;
        this.discardAllFromTelemetry(this.discardSegment);
        this.discardAllFromCSV(this.discardSegment);
    }

    discardAllFromTelemetry(value) {
        this.discardPerformance = value;
        this.discardHumidity = value;
        this.calculateWithoutPerformance = value;
    }

    discardAllFromCSV(value) {
        this.discardPerformanceCSV = value;
        this.discardHumidityCSV = value;
    }

    clickIgnoreAllFromTelemetry() {
        this.discardAllFromTelemetry(this.ignoreAllFromTelemetry);
    }

    clickIgnoreAllFromCSV() {
        this.discardAllFromCSV(this.ignoreAllFromCSV);
    }

    uncheckIgnoreAllFromTelemetry() {
        this.ignoreAllFromTelemetry = false;
    }

    uncheckIgnoreAllFromCSV() {
        this.ignoreAllFromCSV = false;
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    submit() {
        if (!this.isPatch) {
            this.postPeriod();
        } else {
            this.patchSegment();
        }
    }

    @Emit()
    updateSowingRanchLayers(){}

    updateResowingPeriodsList(resowing){
        this.updatePeriodsList([
            {
                "id": resowing['id'],
                "start_date": resowing['start_date'],
                "end_date":  resowing['end_date']
            }
        ])
    }

    postPeriod() {
        this.showLoadingDialog('Guardando...');
        InsuranceServices.postResowingPolygon(this.getData)
            .then(res => {
                this.showSuccessLoadingDialog(res, 'Se ha creado el período de resiembra');
                this.updateResowingPeriodsList(res['new_resowing']);
                this.updateSowingRanchLayers();
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'No se pudo guardar el período de resiembra');
            });
    }

    patchSegment() {
        let idToPatch = this.patchData !== null ? this.patchData['id'] : null;

        if (idToPatch) {
            this.showLoadingDialog('Modificando...');
            InsuranceServices.patchResowingPolygon(idToPatch, this.getData)
                .then(res => {
                    this.showSuccessLoadingDialog(res.data, 'Periodo de resiembra modificado');
                    this.updateResowingPeriodsList(res['data']['resowing'])
                })
                .catch(err => {
                    this.showCatchLoadingDialog(err, 'No se pudo modificar el período de resiembra');
                });
        }
    }

    getParsedDate(date){
        return getDateFormattedAsMoment(date, dateTypes.dateYearFormatReverse)
    }
    getParsedHour(date){
        return getDateFormattedAsMoment(date, dateTypes.hoursAndMinutesFormat)
    }

    loadPatchData() {
        if (this.isPatch && this.patchData !== null) {
            this.modalTitle = 'Modificar período de resiembra';
            let startDate = this.getParsedDate(this.patchData['start_date']);
            let startHour = this.getParsedHour(this.patchData['start_date'])
            let endDate = this.getParsedDate(this.patchData['end_date'])
            let endHour = this.getParsedHour(this.patchData['end_date'])
            this.updateStartDate(startDate);
            this.updateEndDate(endDate);
            this.updateStartHour(startHour);
            this.updateEndHour(endHour);
        } else {
            this.updateStartHour('00:00');
            this.updateEndHour('23:59');
        }
    }

    get getData() {
        return {
            vehicle: this.vehicleID !== -1 ? this.vehicleID : this.vehicleSelected['id'],
            start_date: this.getFullTimestamp(this.startDate, this.startHour),
            end_date: this.getFullTimestamp(this.endDate, this.endHour),
            ranch_id: this.ranchId
        };
    }

    get formIsValid() {
        this.setErrorForm('');
        if (this.startDate == null) {
            this.setErrorForm('No seleccionó Fecha de Inicio');
            return false;
        }

        if (this.endDate == null) {
            this.setErrorForm('No seleccionó Fecha de Fin');
            return false;
        }
        return true;
    }

    getFullTimestamp(date, hour) {
        return date + 'T' + hour;
    }

    @Emit()
    closeModal() {}

    @Emit()
    updatePeriodsList(newPeriodsList) {return newPeriodsList}

    preselectDates(){
        if (!this.isPatch && this.patchData == null) {
            let startDate = getMinDateFromList(this.selectedWorkSegments, 'start');
            let endDate = getMaxDateFromList(this.selectedWorkSegments, 'end');
            this.updateStartDate(this.getParsedDate(startDate));
            this.updateEndDate(this.getParsedDate(endDate));
            this.updateStartHour(this.getParsedHour(startDate));
            this.updateEndHour(this.getParsedHour(endDate));
            this.showPreselectedMessage = true;
        }
    }

    mounted() {
        this.$nextTick(() => {
            this.loadPatchData();
            this.preselectDates();
        });
    }
}
